import React, { useRef, useCallback, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { AddonsConsumer } from '../../Addons';
import PaymentSummary from '../components/PaymentSummary';
import RequestProvider from '../../RequestProvider';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import {
  getStockAssetRecords as getStockAssetRecordsQuery,
  getUserTeamsQuery,
  getCreditsConsumptionQuery,
  getContractsQuery,
  getVideoPaymentStatus,
  customPaymentCheckout } from
'../../../common/api';
import {
  getOrganisationQuery,
  getTeamQuery,
  updatePurchaseOrderIdQuery } from
'../api';
import { getFinanceBillables } from '@core/shared/api/financeApi';
import { PRINT_STYLE } from '../styles/paymentSummary';
import { withFlagsConsumer } from '../../FeatureFlags';

const INITIAL_ACCORDION_OPEN_INDEX_HIDDEN = 1;
const INITIAL_ACCORDION_OPEN_INDEX_SHOW = 0;
























function PaymentSummaryContainer(props) {
  const paymentSummaryComponentRef = useRef();

  const { organisationId, onCreditsUpdated } = props;
  const [initialAccordionOpenIndex, setInitialAccordionOpenIndex] = useState(
    INITIAL_ACCORDION_OPEN_INDEX_HIDDEN
  );

  const onBeforePrint = useCallback(() => new Promise((resolve) => {
    setInitialAccordionOpenIndex(INITIAL_ACCORDION_OPEN_INDEX_SHOW);
    resolve();
  }), []);

  const handlePrint = useReactToPrint({
    content: () => paymentSummaryComponentRef.current,
    pageStyle: PRINT_STYLE,
    onBeforeGetContent: () => onBeforePrint(),
    onAfterPrint: () => setInitialAccordionOpenIndex(INITIAL_ACCORDION_OPEN_INDEX_HIDDEN)
  });

  return (
    <RequestProvider
      requests={{
        getOrganisation: getOrganisationQuery(organisationId),
        getTeam: getTeamQuery(),
        updatePurchaseOrderId: updatePurchaseOrderIdQuery(),
        getStockAssetRecords: getStockAssetRecordsQuery(organisationId),
        getUserTeams: getUserTeamsQuery(organisationId),
        getCreditsConsumption: getCreditsConsumptionQuery(organisationId),
        getContracts: getContractsQuery(),
        getVideoPaymentStatus: getVideoPaymentStatus(),
        getFinanceBillables: getFinanceBillables(organisationId),
        customPaymentCheckout: customPaymentCheckout()
      }}>

      {(requests) =>
      <AuthorisationConsumer>
          {({
          isShootstaAdmin,
          isShootstaSeniorEditor,
          isShootstaAccountManager
        }) =>
        <AddonsConsumer>
              {({
            constants: { ADDITIONAL_OUTPUT },
            actions: { getCurrencySymbol, getCurrencyIcon }
          }) =>
          <PaymentSummary
            getCurrencySymbol={getCurrencySymbol}
            getCurrencyIcon={getCurrencyIcon}
            additionalOutputCost={ADDITIONAL_OUTPUT?.[0]?.cost}
            onCreditsUpdated={onCreditsUpdated}
            initialOpenIndex={initialAccordionOpenIndex}
            componentRef={paymentSummaryComponentRef}
            handlePrint={handlePrint}
            isShootstaAdmin={isShootstaAdmin}
            isShootstaSeniorEditor={isShootstaSeniorEditor}
            isShootstaAccountManager={isShootstaAccountManager}
            {...requests}
            {...props} />}


            </AddonsConsumer>}

        </AuthorisationConsumer>}

    </RequestProvider>);

}

export default withFlagsConsumer(PaymentSummaryContainer);